import { render, staticRenderFns } from "./preEndSurvey.vue?vue&type=template&id=2d481f1a&"
import script from "./preEndSurvey.vue?vue&type=script&lang=js&"
export * from "./preEndSurvey.vue?vue&type=script&lang=js&"
import style0 from "./preEndSurvey.vue?vue&type=style&index=0&id=2d481f1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports